<template>
    <div class="flex justify-start flex-wrap -mb-3" :class="{'flex-col':column}">
        <label v-for="(value) in orderedOption" :key="value.api_source_id" :class="type" class="ml-6 mb-3 last:mr-0">
            <span v-if="type.indexOf('switch') !== -1" v-show="showLabel" class="control-label pr-3 pl-0">
                {{ value.label }}
            </span>
            <input
                :type="inputType"
                :name="name"
                v-model="computedValue"
                :value="value.api_source_id"
                :disabled="value.order > priority && priority != 0">
            <span class="check"></span>
            <span v-if="type.indexOf('switch') === -1" v-show="showLabel" class="control-label pr-3 pl-0">
                {{ value.label }}
            </span>
        </label>
    </div>
</template>

<style>
.checkbox input[type=checkbox][disabled] + .check,
.checkbox input[type=checkbox][disabled] + .check + .control-label {
    opacity: .5;
}
</style>

<script>
import {computed} from 'vue'

export default {
    name: 'PricesPicker',
    props: {
        options: {
            type: Object,
            default: () => {
            }
        },
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'checkbox'
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        priority: {
            type: Number,
            default: 0
        },
        column: Boolean,
        modelValue: [String, Number, Boolean, Array]
    },
    emits: ['update:modelValue'],
    setup(props, {emit}) {
        const computedValue = computed({
            get: () => props.modelValue,
            set: value => {
                emit('update:modelValue', value)
            }
        })

        const orderedOption = props.options.sort((a, b) => {
            if (a.order == b.order) {
                return b.label < a.label ? -1 : 1
            }
            return a.order < b.order ? -1 : 1
        })

        const inputType = computed(() => props.type === 'radio' ? 'radio' : 'checkbox')

        return {
            computedValue,
            inputType,
            orderedOption
        }
    }
}
</script>
